import React from 'react';
import { RETAILER_LOGOS } from './RetailerLogo';

const RetailerCard = ({ name, href, platform }) => {
  const Logo = RETAILER_LOGOS[platform];

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`retailer-card retailer-card--${platform}`}
      aria-label={`Buy on ${name}`}
    >
      <span className="retailer-card-logo">
        {Logo && <Logo />}
      </span>
      <span className="retailer-card-label">Buy on {name}</span>
    </a>
  );
};

export default RetailerCard;
